module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/9-ff6ffeca5375f7c29770605f0e73e7a1.svg";